import React from 'react';
import BaseDialog from '../BaseDialog';

const ErrorDialog = ({ isVisible, onClose, message }) => {
  return (
    <BaseDialog isVisible={isVisible} onClose={onClose}>
      <div style={{ padding: '8px 4px' }}>
        <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>
          エラー
        </div>
        <div style={{ fontSize: '14px', color: '#333', marginBottom: '12px', whiteSpace: 'pre-wrap' }}>
          {message || 'エラーが発生しました。'}
        </div>
        <button
          type="button"
          onClick={onClose}
          style={{
            padding: '8px 14px',
            border: '1px solid #ccc',
            borderRadius: '6px',
            backgroundColor: '#f5f5f5',
            cursor: 'pointer',
          }}
        >
          閉じる
        </button>
      </div>
    </BaseDialog>
  );
};

export default ErrorDialog;
